<template>
  <div
    v-if="isShowError"
    class="authorize-error">
    <div class="authorize-error__icon">!</div>
    <div class="authorize-error__errors">
      {{ getRegError }}
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import isEmpty from 'lodash/isEmpty'

  export default {
    name: 'Error',
    computed: {
      ...mapGetters('auth', [
        'getRegError'
      ]),
      isShowError: function () {
        return !isEmpty(this.getRegError)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Auth/Register/Error.vue